module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/gallery/close-478f147eb89fb858c28c8943f636cc49.png";